module.exports = __webpack_public_path__ + "static/after1-38b23b5744bfc7f6fd90a1c51f3ea9ab.jpg";